/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch.ts";
import type {
	CreateThirdPartyDevice400,
	CreateThirdPartyDevice401,
	CreateThirdPartyDevice403,
	CreateThirdPartyDevice409,
	CreateThirdPartyDevice500,
	DeleteThirdPartyDevice400,
	DeleteThirdPartyDevice404,
	DeleteThirdPartyDevice500,
	GetThirdPartyDevice400,
	GetThirdPartyDevice404,
	GetThirdPartyDevice500,
	GetThirdPartyDeviceHistorySync400,
	GetThirdPartyDeviceHistorySync404,
	GetThirdPartyDeviceHistorySync500,
	ListThirdPartyDevices400,
	ListThirdPartyDevices500,
	ResumeThirdPartyDeviceHistory400,
	ResumeThirdPartyDeviceHistory404,
	ResumeThirdPartyDeviceHistory409,
	ResumeThirdPartyDeviceHistory500,
	SetThirdPartyDeviceCredential400,
	SetThirdPartyDeviceCredential404,
	SetThirdPartyDeviceCredential422,
	SetThirdPartyDeviceCredential500,
	SetThirdPartyDeviceCredentialBody,
	StationHistoryResumeResponse,
	StationHistorySync,
	ThirdPartyDevice,
	ThirdPartyDeviceCreate,
	ThirdPartyDeviceUpdate,
	UpdateThirdPartyDevice400,
	UpdateThirdPartyDevice404,
	UpdateThirdPartyDevice500,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
	query: T,
	queryKey: K,
): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K };
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === "queryKey") continue;
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key],
		});
	}
	return result;
};

export const getListThirdPartyDevicesUrl = () => {
	return `/third-party-devices`;
};

/**
 * @summary List all third-party devices owned by the authenticated user
 */
export const listThirdPartyDevices = async (
	options?: Parameters<typeof customFetch>[1],
): Promise<ThirdPartyDevice[]> => {
	return customFetch<ThirdPartyDevice[]>(getListThirdPartyDevicesUrl(), {
		...options,
		method: "GET",
	});
};

export const getListThirdPartyDevicesQueryKey = () => {
	return ["third-party-devices"] as const;
};

export const getListThirdPartyDevicesQueryOptions = <
	TData = Awaited<ReturnType<typeof listThirdPartyDevices>>,
	TError = ListThirdPartyDevices400 | ListThirdPartyDevices500,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof listThirdPartyDevices>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customFetch>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListThirdPartyDevicesQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listThirdPartyDevices>>
	> = ({ signal }) => listThirdPartyDevices({ signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listThirdPartyDevices>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListThirdPartyDevicesQueryResult = NonNullable<
	Awaited<ReturnType<typeof listThirdPartyDevices>>
>;
export type ListThirdPartyDevicesQueryError =
	| ListThirdPartyDevices400
	| ListThirdPartyDevices500;

export function useListThirdPartyDevices<
	TData = Awaited<ReturnType<typeof listThirdPartyDevices>>,
	TError = ListThirdPartyDevices400 | ListThirdPartyDevices500,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listThirdPartyDevices>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listThirdPartyDevices>>,
					TError,
					Awaited<ReturnType<typeof listThirdPartyDevices>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListThirdPartyDevices<
	TData = Awaited<ReturnType<typeof listThirdPartyDevices>>,
	TError = ListThirdPartyDevices400 | ListThirdPartyDevices500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listThirdPartyDevices>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listThirdPartyDevices>>,
					TError,
					Awaited<ReturnType<typeof listThirdPartyDevices>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListThirdPartyDevices<
	TData = Awaited<ReturnType<typeof listThirdPartyDevices>>,
	TError = ListThirdPartyDevices400 | ListThirdPartyDevices500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listThirdPartyDevices>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all third-party devices owned by the authenticated user
 */

export function useListThirdPartyDevices<
	TData = Awaited<ReturnType<typeof listThirdPartyDevices>>,
	TError = ListThirdPartyDevices400 | ListThirdPartyDevices500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listThirdPartyDevices>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListThirdPartyDevicesQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List all third-party devices owned by the authenticated user
 */
export const useSetListThirdPartyDevicesQueryData = () => {
	const queryClient = useQueryClient();
	return (
		updater:
			| Awaited<ReturnType<typeof listThirdPartyDevices>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listThirdPartyDevices>> | undefined,
			  ) => Awaited<ReturnType<typeof listThirdPartyDevices>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listThirdPartyDevices>>
		>(
			{ exact: $exactMatch, queryKey: getListThirdPartyDevicesQueryKey() },
			updater,
		);
	};
};

/**
 * @summary List all third-party devices owned by the authenticated user
 */
export const useGetListThirdPartyDevicesQueryData = () => {
	const queryClient = useQueryClient();
	return () =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listThirdPartyDevices>>>(
			getListThirdPartyDevicesQueryKey(),
		);
};

export const getCreateThirdPartyDeviceUrl = () => {
	return `/third-party-devices`;
};

/**
 * @summary Register a new third-party device
 */
export const createThirdPartyDevice = async (
	thirdPartyDeviceCreate: ThirdPartyDeviceCreate,
	options?: Parameters<typeof customFetch>[1],
): Promise<ThirdPartyDevice> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<ThirdPartyDevice>(getCreateThirdPartyDeviceUrl(), {
		...options,
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			...getHeaders(options?.headers),
		},
		body: JSON.stringify(thirdPartyDeviceCreate),
	});
};

export const getCreateThirdPartyDeviceMutationKey = () =>
	["createThirdPartyDevice"] as const;

export const getCreateThirdPartyDeviceMutationOptions = <
	TError =
		| CreateThirdPartyDevice400
		| CreateThirdPartyDevice401
		| CreateThirdPartyDevice403
		| CreateThirdPartyDevice409
		| CreateThirdPartyDevice500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createThirdPartyDevice>>,
		TError,
		CreateThirdPartyDeviceMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createThirdPartyDevice>>,
	TError,
	CreateThirdPartyDeviceMutationVariables,
	TContext
> => {
	const mutationKey = getCreateThirdPartyDeviceMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createThirdPartyDevice>>,
		CreateThirdPartyDeviceMutationVariables
	> = (props) => {
		const { data } = props ?? {};

		return createThirdPartyDevice(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateThirdPartyDeviceMutationResult = NonNullable<
	Awaited<ReturnType<typeof createThirdPartyDevice>>
>;
export type CreateThirdPartyDeviceMutationBody = ThirdPartyDeviceCreate;
export type CreateThirdPartyDeviceMutationError =
	| CreateThirdPartyDevice400
	| CreateThirdPartyDevice401
	| CreateThirdPartyDevice403
	| CreateThirdPartyDevice409
	| CreateThirdPartyDevice500;
export type CreateThirdPartyDeviceMutationVariables = {
	data: ThirdPartyDeviceCreate;
};

/**
 * @summary Register a new third-party device
 */
export const useCreateThirdPartyDevice = <
	TError =
		| CreateThirdPartyDevice400
		| CreateThirdPartyDevice401
		| CreateThirdPartyDevice403
		| CreateThirdPartyDevice409
		| CreateThirdPartyDevice500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createThirdPartyDevice>>,
			TError,
			CreateThirdPartyDeviceMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof createThirdPartyDevice>>,
	TError,
	CreateThirdPartyDeviceMutationVariables,
	TContext
> => {
	return useMutation(
		getCreateThirdPartyDeviceMutationOptions(options),
		queryClient,
	);
};
export const getGetThirdPartyDeviceUrl = (thirdPartyDeviceId: string) => {
	return `/third-party-devices/${thirdPartyDeviceId}`;
};

/**
 * @summary Get a single third-party device by ID
 */
export const getThirdPartyDevice = async (
	thirdPartyDeviceId: string,
	options?: Parameters<typeof customFetch>[1],
): Promise<ThirdPartyDevice> => {
	return customFetch<ThirdPartyDevice>(
		getGetThirdPartyDeviceUrl(thirdPartyDeviceId),
		{
			...options,
			method: "GET",
		},
	);
};

export const getGetThirdPartyDeviceQueryKey = (thirdPartyDeviceId: string) => {
	return ["third-party-devices", thirdPartyDeviceId] as const;
};

export const getGetThirdPartyDeviceQueryOptions = <
	TData = Awaited<ReturnType<typeof getThirdPartyDevice>>,
	TError =
		| GetThirdPartyDevice400
		| GetThirdPartyDevice404
		| GetThirdPartyDevice500,
>(
	thirdPartyDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDevice>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetThirdPartyDeviceQueryKey(thirdPartyDeviceId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getThirdPartyDevice>>
	> = ({ signal }) =>
		getThirdPartyDevice(thirdPartyDeviceId, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: thirdPartyDeviceId !== null && thirdPartyDeviceId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getThirdPartyDevice>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetThirdPartyDeviceQueryResult = NonNullable<
	Awaited<ReturnType<typeof getThirdPartyDevice>>
>;
export type GetThirdPartyDeviceQueryError =
	| GetThirdPartyDevice400
	| GetThirdPartyDevice404
	| GetThirdPartyDevice500;

export function useGetThirdPartyDevice<
	TData = Awaited<ReturnType<typeof getThirdPartyDevice>>,
	TError =
		| GetThirdPartyDevice400
		| GetThirdPartyDevice404
		| GetThirdPartyDevice500,
>(
	thirdPartyDeviceId: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDevice>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getThirdPartyDevice>>,
					TError,
					Awaited<ReturnType<typeof getThirdPartyDevice>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetThirdPartyDevice<
	TData = Awaited<ReturnType<typeof getThirdPartyDevice>>,
	TError =
		| GetThirdPartyDevice400
		| GetThirdPartyDevice404
		| GetThirdPartyDevice500,
>(
	thirdPartyDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDevice>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getThirdPartyDevice>>,
					TError,
					Awaited<ReturnType<typeof getThirdPartyDevice>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetThirdPartyDevice<
	TData = Awaited<ReturnType<typeof getThirdPartyDevice>>,
	TError =
		| GetThirdPartyDevice400
		| GetThirdPartyDevice404
		| GetThirdPartyDevice500,
>(
	thirdPartyDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDevice>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single third-party device by ID
 */

export function useGetThirdPartyDevice<
	TData = Awaited<ReturnType<typeof getThirdPartyDevice>>,
	TError =
		| GetThirdPartyDevice400
		| GetThirdPartyDevice404
		| GetThirdPartyDevice500,
>(
	thirdPartyDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDevice>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetThirdPartyDeviceQueryOptions(
		thirdPartyDeviceId,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a single third-party device by ID
 */
export const useSetGetThirdPartyDeviceQueryData = () => {
	const queryClient = useQueryClient();
	return (
		thirdPartyDeviceId: string,
		updater:
			| Awaited<ReturnType<typeof getThirdPartyDevice>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getThirdPartyDevice>> | undefined,
			  ) => Awaited<ReturnType<typeof getThirdPartyDevice>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getThirdPartyDevice>>>(
			{
				exact: $exactMatch,
				queryKey: getGetThirdPartyDeviceQueryKey(thirdPartyDeviceId),
			},
			updater,
		);
	};
};

/**
 * @summary Get a single third-party device by ID
 */
export const useGetGetThirdPartyDeviceQueryData = () => {
	const queryClient = useQueryClient();
	return (thirdPartyDeviceId: string) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getThirdPartyDevice>>>(
			getGetThirdPartyDeviceQueryKey(thirdPartyDeviceId),
		);
};

export const getUpdateThirdPartyDeviceUrl = (thirdPartyDeviceId: string) => {
	return `/third-party-devices/${thirdPartyDeviceId}`;
};

/**
 * @summary Update an existing third-party device
 */
export const updateThirdPartyDevice = async (
	thirdPartyDeviceId: string,
	thirdPartyDeviceUpdate: ThirdPartyDeviceUpdate,
	options?: Parameters<typeof customFetch>[1],
): Promise<ThirdPartyDevice> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<ThirdPartyDevice>(
		getUpdateThirdPartyDeviceUrl(thirdPartyDeviceId),
		{
			...options,
			method: "PATCH",
			headers: {
				"Content-Type": "application/json",
				...getHeaders(options?.headers),
			},
			body: JSON.stringify(thirdPartyDeviceUpdate),
		},
	);
};

export const getUpdateThirdPartyDeviceMutationKey = () =>
	["updateThirdPartyDevice"] as const;

export const getUpdateThirdPartyDeviceMutationOptions = <
	TError =
		| UpdateThirdPartyDevice400
		| UpdateThirdPartyDevice404
		| UpdateThirdPartyDevice500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateThirdPartyDevice>>,
		TError,
		UpdateThirdPartyDeviceMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateThirdPartyDevice>>,
	TError,
	UpdateThirdPartyDeviceMutationVariables,
	TContext
> => {
	const mutationKey = getUpdateThirdPartyDeviceMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateThirdPartyDevice>>,
		UpdateThirdPartyDeviceMutationVariables
	> = (props) => {
		const { thirdPartyDeviceId, data } = props ?? {};

		return updateThirdPartyDevice(thirdPartyDeviceId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateThirdPartyDeviceMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateThirdPartyDevice>>
>;
export type UpdateThirdPartyDeviceMutationBody = ThirdPartyDeviceUpdate;
export type UpdateThirdPartyDeviceMutationError =
	| UpdateThirdPartyDevice400
	| UpdateThirdPartyDevice404
	| UpdateThirdPartyDevice500;
export type UpdateThirdPartyDeviceMutationVariables = {
	thirdPartyDeviceId: string;
	data: ThirdPartyDeviceUpdate;
};

/**
 * @summary Update an existing third-party device
 */
export const useUpdateThirdPartyDevice = <
	TError =
		| UpdateThirdPartyDevice400
		| UpdateThirdPartyDevice404
		| UpdateThirdPartyDevice500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateThirdPartyDevice>>,
			TError,
			UpdateThirdPartyDeviceMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateThirdPartyDevice>>,
	TError,
	UpdateThirdPartyDeviceMutationVariables,
	TContext
> => {
	return useMutation(
		getUpdateThirdPartyDeviceMutationOptions(options),
		queryClient,
	);
};
export const getDeleteThirdPartyDeviceUrl = (thirdPartyDeviceId: string) => {
	return `/third-party-devices/${thirdPartyDeviceId}`;
};

/**
 * @summary Soft-delete a third-party device; adding it again, or clearing `deleted`, revives it
 */
export const deleteThirdPartyDevice = async (
	thirdPartyDeviceId: string,
	options?: Parameters<typeof customFetch>[1],
): Promise<ThirdPartyDevice> => {
	return customFetch<ThirdPartyDevice>(
		getDeleteThirdPartyDeviceUrl(thirdPartyDeviceId),
		{
			...options,
			method: "DELETE",
		},
	);
};

export const getDeleteThirdPartyDeviceMutationKey = () =>
	["deleteThirdPartyDevice"] as const;

export const getDeleteThirdPartyDeviceMutationOptions = <
	TError =
		| DeleteThirdPartyDevice400
		| DeleteThirdPartyDevice404
		| DeleteThirdPartyDevice500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteThirdPartyDevice>>,
		TError,
		DeleteThirdPartyDeviceMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteThirdPartyDevice>>,
	TError,
	DeleteThirdPartyDeviceMutationVariables,
	TContext
> => {
	const mutationKey = getDeleteThirdPartyDeviceMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteThirdPartyDevice>>,
		DeleteThirdPartyDeviceMutationVariables
	> = (props) => {
		const { thirdPartyDeviceId } = props ?? {};

		return deleteThirdPartyDevice(thirdPartyDeviceId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteThirdPartyDeviceMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteThirdPartyDevice>>
>;

export type DeleteThirdPartyDeviceMutationError =
	| DeleteThirdPartyDevice400
	| DeleteThirdPartyDevice404
	| DeleteThirdPartyDevice500;
export type DeleteThirdPartyDeviceMutationVariables = {
	thirdPartyDeviceId: string;
};

/**
 * @summary Soft-delete a third-party device; adding it again, or clearing `deleted`, revives it
 */
export const useDeleteThirdPartyDevice = <
	TError =
		| DeleteThirdPartyDevice400
		| DeleteThirdPartyDevice404
		| DeleteThirdPartyDevice500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteThirdPartyDevice>>,
			TError,
			DeleteThirdPartyDeviceMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof deleteThirdPartyDevice>>,
	TError,
	DeleteThirdPartyDeviceMutationVariables,
	TContext
> => {
	return useMutation(
		getDeleteThirdPartyDeviceMutationOptions(options),
		queryClient,
	);
};
export const getSetThirdPartyDeviceCredentialUrl = (
	thirdPartyDeviceId: string,
) => {
	return `/third-party-devices/${thirdPartyDeviceId}/credential`;
};

/**
 * @summary Set which of the organization's API credentials a third-party device polls with
 */
export const setThirdPartyDeviceCredential = async (
	thirdPartyDeviceId: string,
	setThirdPartyDeviceCredentialBody: SetThirdPartyDeviceCredentialBody,
	options?: Parameters<typeof customFetch>[1],
): Promise<ThirdPartyDevice> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<ThirdPartyDevice>(
		getSetThirdPartyDeviceCredentialUrl(thirdPartyDeviceId),
		{
			...options,
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				...getHeaders(options?.headers),
			},
			body: JSON.stringify(setThirdPartyDeviceCredentialBody),
		},
	);
};

export const getSetThirdPartyDeviceCredentialMutationKey = () =>
	["setThirdPartyDeviceCredential"] as const;

export const getSetThirdPartyDeviceCredentialMutationOptions = <
	TError =
		| SetThirdPartyDeviceCredential400
		| SetThirdPartyDeviceCredential404
		| SetThirdPartyDeviceCredential422
		| SetThirdPartyDeviceCredential500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof setThirdPartyDeviceCredential>>,
		TError,
		SetThirdPartyDeviceCredentialMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof setThirdPartyDeviceCredential>>,
	TError,
	SetThirdPartyDeviceCredentialMutationVariables,
	TContext
> => {
	const mutationKey = getSetThirdPartyDeviceCredentialMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof setThirdPartyDeviceCredential>>,
		SetThirdPartyDeviceCredentialMutationVariables
	> = (props) => {
		const { thirdPartyDeviceId, data } = props ?? {};

		return setThirdPartyDeviceCredential(
			thirdPartyDeviceId,
			data,
			requestOptions,
		);
	};

	return { mutationFn, ...mutationOptions };
};

export type SetThirdPartyDeviceCredentialMutationResult = NonNullable<
	Awaited<ReturnType<typeof setThirdPartyDeviceCredential>>
>;
export type SetThirdPartyDeviceCredentialMutationBody =
	SetThirdPartyDeviceCredentialBody;
export type SetThirdPartyDeviceCredentialMutationError =
	| SetThirdPartyDeviceCredential400
	| SetThirdPartyDeviceCredential404
	| SetThirdPartyDeviceCredential422
	| SetThirdPartyDeviceCredential500;
export type SetThirdPartyDeviceCredentialMutationVariables = {
	thirdPartyDeviceId: string;
	data: SetThirdPartyDeviceCredentialBody;
};

/**
 * @summary Set which of the organization's API credentials a third-party device polls with
 */
export const useSetThirdPartyDeviceCredential = <
	TError =
		| SetThirdPartyDeviceCredential400
		| SetThirdPartyDeviceCredential404
		| SetThirdPartyDeviceCredential422
		| SetThirdPartyDeviceCredential500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof setThirdPartyDeviceCredential>>,
			TError,
			SetThirdPartyDeviceCredentialMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof setThirdPartyDeviceCredential>>,
	TError,
	SetThirdPartyDeviceCredentialMutationVariables,
	TContext
> => {
	return useMutation(
		getSetThirdPartyDeviceCredentialMutationOptions(options),
		queryClient,
	);
};
export const getGetThirdPartyDeviceHistorySyncUrl = (
	thirdPartyDeviceId: string,
) => {
	return `/third-party-devices/${thirdPartyDeviceId}/history-sync`;
};

/**
 * @summary How a WeatherLink station's history import is going: how far back, what is left, and an estimate
 */
export const getThirdPartyDeviceHistorySync = async (
	thirdPartyDeviceId: string,
	options?: Parameters<typeof customFetch>[1],
): Promise<StationHistorySync> => {
	return customFetch<StationHistorySync>(
		getGetThirdPartyDeviceHistorySyncUrl(thirdPartyDeviceId),
		{
			...options,
			method: "GET",
		},
	);
};

export const getGetThirdPartyDeviceHistorySyncQueryKey = (
	thirdPartyDeviceId: string,
) => {
	return ["third-party-devices", thirdPartyDeviceId, "history-sync"] as const;
};

export const getGetThirdPartyDeviceHistorySyncQueryOptions = <
	TData = Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>,
	TError =
		| GetThirdPartyDeviceHistorySync400
		| GetThirdPartyDeviceHistorySync404
		| GetThirdPartyDeviceHistorySync500,
>(
	thirdPartyDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetThirdPartyDeviceHistorySyncQueryKey(thirdPartyDeviceId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>
	> = ({ signal }) =>
		getThirdPartyDeviceHistorySync(thirdPartyDeviceId, {
			signal,
			...requestOptions,
		});

	return {
		queryKey,
		queryFn,
		enabled: thirdPartyDeviceId !== null && thirdPartyDeviceId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetThirdPartyDeviceHistorySyncQueryResult = NonNullable<
	Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>
>;
export type GetThirdPartyDeviceHistorySyncQueryError =
	| GetThirdPartyDeviceHistorySync400
	| GetThirdPartyDeviceHistorySync404
	| GetThirdPartyDeviceHistorySync500;

export function useGetThirdPartyDeviceHistorySync<
	TData = Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>,
	TError =
		| GetThirdPartyDeviceHistorySync400
		| GetThirdPartyDeviceHistorySync404
		| GetThirdPartyDeviceHistorySync500,
>(
	thirdPartyDeviceId: string,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>,
					TError,
					Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetThirdPartyDeviceHistorySync<
	TData = Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>,
	TError =
		| GetThirdPartyDeviceHistorySync400
		| GetThirdPartyDeviceHistorySync404
		| GetThirdPartyDeviceHistorySync500,
>(
	thirdPartyDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>,
					TError,
					Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetThirdPartyDeviceHistorySync<
	TData = Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>,
	TError =
		| GetThirdPartyDeviceHistorySync400
		| GetThirdPartyDeviceHistorySync404
		| GetThirdPartyDeviceHistorySync500,
>(
	thirdPartyDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary How a WeatherLink station's history import is going: how far back, what is left, and an estimate
 */

export function useGetThirdPartyDeviceHistorySync<
	TData = Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>,
	TError =
		| GetThirdPartyDeviceHistorySync400
		| GetThirdPartyDeviceHistorySync404
		| GetThirdPartyDeviceHistorySync500,
>(
	thirdPartyDeviceId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetThirdPartyDeviceHistorySyncQueryOptions(
		thirdPartyDeviceId,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary How a WeatherLink station's history import is going: how far back, what is left, and an estimate
 */
export const useSetGetThirdPartyDeviceHistorySyncQueryData = () => {
	const queryClient = useQueryClient();
	return (
		thirdPartyDeviceId: string,
		updater:
			| Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>
			| undefined
			| ((
					old:
						| Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>
						| undefined,
			  ) =>
					| Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>
					| undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>
		>(
			{
				exact: $exactMatch,
				queryKey: getGetThirdPartyDeviceHistorySyncQueryKey(thirdPartyDeviceId),
			},
			updater,
		);
	};
};

/**
 * @summary How a WeatherLink station's history import is going: how far back, what is left, and an estimate
 */
export const useGetGetThirdPartyDeviceHistorySyncQueryData = () => {
	const queryClient = useQueryClient();
	return (thirdPartyDeviceId: string) =>
		queryClient.getQueryData<
			Awaited<ReturnType<typeof getThirdPartyDeviceHistorySync>>
		>(getGetThirdPartyDeviceHistorySyncQueryKey(thirdPartyDeviceId));
};

export const getResumeThirdPartyDeviceHistoryUrl = (
	thirdPartyDeviceId: string,
) => {
	return `/third-party-devices/${thirdPartyDeviceId}/resume-history`;
};

/**
 * @summary Retry a WeatherLink station's history import that WeatherLink refused
 */
export const resumeThirdPartyDeviceHistory = async (
	thirdPartyDeviceId: string,
	options?: Parameters<typeof customFetch>[1],
): Promise<StationHistoryResumeResponse> => {
	return customFetch<StationHistoryResumeResponse>(
		getResumeThirdPartyDeviceHistoryUrl(thirdPartyDeviceId),
		{
			...options,
			method: "POST",
		},
	);
};

export const getResumeThirdPartyDeviceHistoryMutationKey = () =>
	["resumeThirdPartyDeviceHistory"] as const;

export const getResumeThirdPartyDeviceHistoryMutationOptions = <
	TError =
		| ResumeThirdPartyDeviceHistory400
		| ResumeThirdPartyDeviceHistory404
		| ResumeThirdPartyDeviceHistory409
		| ResumeThirdPartyDeviceHistory500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof resumeThirdPartyDeviceHistory>>,
		TError,
		ResumeThirdPartyDeviceHistoryMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof resumeThirdPartyDeviceHistory>>,
	TError,
	ResumeThirdPartyDeviceHistoryMutationVariables,
	TContext
> => {
	const mutationKey = getResumeThirdPartyDeviceHistoryMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof resumeThirdPartyDeviceHistory>>,
		ResumeThirdPartyDeviceHistoryMutationVariables
	> = (props) => {
		const { thirdPartyDeviceId } = props ?? {};

		return resumeThirdPartyDeviceHistory(thirdPartyDeviceId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ResumeThirdPartyDeviceHistoryMutationResult = NonNullable<
	Awaited<ReturnType<typeof resumeThirdPartyDeviceHistory>>
>;

export type ResumeThirdPartyDeviceHistoryMutationError =
	| ResumeThirdPartyDeviceHistory400
	| ResumeThirdPartyDeviceHistory404
	| ResumeThirdPartyDeviceHistory409
	| ResumeThirdPartyDeviceHistory500;
export type ResumeThirdPartyDeviceHistoryMutationVariables = {
	thirdPartyDeviceId: string;
};

/**
 * @summary Retry a WeatherLink station's history import that WeatherLink refused
 */
export const useResumeThirdPartyDeviceHistory = <
	TError =
		| ResumeThirdPartyDeviceHistory400
		| ResumeThirdPartyDeviceHistory404
		| ResumeThirdPartyDeviceHistory409
		| ResumeThirdPartyDeviceHistory500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof resumeThirdPartyDeviceHistory>>,
			TError,
			ResumeThirdPartyDeviceHistoryMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof resumeThirdPartyDeviceHistory>>,
	TError,
	ResumeThirdPartyDeviceHistoryMutationVariables,
	TContext
> => {
	return useMutation(
		getResumeThirdPartyDeviceHistoryMutationOptions(options),
		queryClient,
	);
};
